import useSWR from "swr";
import { Order, toOrder } from "@/fm/data/orders";

interface UseSubscriptionOrderQueryReturn {
  data: Order | undefined;
}

// The membership's purchase order, in the same shape the dashboard's order
// query yields, so the portal can hand it to the receipt generator the
// dashboard uses (useDownloadMembershipChargeReceipt) without a second mapper.
export function useSubscriptionOrderQuery(
  partnerId: string,
  subscriptionId: string
): UseSubscriptionOrderQueryReturn {
  const { data } = useSWR(
    `/api/v3/portal/partners/${partnerId}/subscriptions/${subscriptionId}/order`
  );

  return { data: data?.data ? toOrder(data.data) : undefined };
}
